import * as Actions from '../../actions/integration/type';

const initialState = {
  // Test Torque Payment Creds

  torquePayTestCredsLoading: false,
  torquePayTestCredsSuccess: false,
  torquePayTestCredsError: '',

  // Get Torque Payment Creds

  getTorquePayCredsLoading: false,
  getTorquePayCreds: '',
  getTorquePayCredsError: '',

  // Add Torque Payment Creds

  isLoading: false,
  addTorquePayCredsSuccess: '',
  addTorquePayCredsError: '',

  // Delete Torque Payment Creds

  deleteTorquePayCredsLoading: false,
  deleteTorquePayCredsSuccess: '',
  deleteTorquePayCredsError: '',

  // Create Torque Payment

  makeTorquePayLoading: false,
  makeTorquePaySuccess: '',
  makeTorquePayError: '',
};

export const torquePayReducer = (state = initialState, action) => {
  switch (action.type) {
    // Test Torque Payment Creds

    case Actions.TEST_TORQUE_PAY_CREDS_REQUEST:
      return {
        ...state,
        torquePayTestCredsLoading: true,
      };
    case Actions.TEST_TORQUE_PAY_CREDS_SUCCESS:
      return {
        ...state,
        torquePayTestCredsLoading: false,
        torquePayTestCredsSuccess: true,
      };
    case Actions.TEST_TORQUE_PAY_CREDS_FAIL:
      return {
        ...state,
        torquePayTestCredsLoading: false,
        torquePayTestCredsError: action.payload || 'error',
      };
    case Actions.CLEAR_TEST_TORQUE_PAY_CREDS_STATE:
      return {
        ...state,
        torquePayTestCredsLoading: false,
        torquePayTestCredsSuccess: false,
        torquePayTestCredsError: '',
      };

    // Get Torque Payment Creds

    case Actions.GET_TORQUE_PAY_CREDS_REQUEST:
      return {
        ...state,
        getTorquePayCredsLoading: true,
      };
    case Actions.GET_TORQUE_PAY_CREDS_SUCCESS:
      return {
        ...state,
        getTorquePayCredsLoading: false,
        getTorquePayCreds: action.payload || '',
      };
    case Actions.GET_TORQUE_PAY_CREDS_FAIL:
      return {
        ...state,
        getTorquePayCredsLoading: false,
        getTorquePayCredsError: action.payload,
      };

    // Add Torque Payment Creds

    case Actions.ADD_TORQUE_PAY_CREDS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.ADD_TORQUE_PAY_CREDS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        addTorquePayCredsSuccess: 'Success',
      };
    case Actions.ADD_TORQUE_PAY_CREDS_FAIL:
      return {
        ...state,
        isLoading: false,
        addTorquePayCredsError: action.payload,
      };

    // Delete Torque Payment Creds

    case Actions.DELETE_TORQUE_PAY_CREDS_REQUEST:
      return {
        ...state,
        deleteTorquePayCredsLoading: true,
      };
    case Actions.DELETE_TORQUE_PAY_CREDS_SUCCESS:
      return {
        ...state,
        deleteTorquePayCredsLoading: false,
        deleteTorquePayCredsSuccess: 'Success',
      };
    case Actions.DELETE_TORQUE_PAY_CREDS_FAIL:
      return {
        ...state,
        deleteTorquePayCredsLoading: false,
        deleteTorquePayCredsError: action.payload,
      };

    // Make Torque Payment

    case Actions.MAKE_TORQUE_PAY_REQUEST:
      return {
        ...state,
        makeTorquePayLoading: true,
      };
    case Actions.MAKE_TORQUE_PAY_SUCCESS:
      return {
        ...state,
        makeTorquePayLoading: false,
        makeTorquePaySuccess: action.payload,
      };
    case Actions.MAKE_TORQUE_PAY_FAIL:
      return {
        ...state,
        makeTorquePayLoading: false,
        makeTorquePayError: action.payload,
      };

    // Clear States

    case 'CLEAR_TORQUE_PAY_STATE':
      return {
        ...state,
        torquePayTestCredsLoading: false,
        torquePayTestCredsSuccess: false,
        torquePayTestCredsError: '',

        getTorquePayCredsLoading: false,
        getTorquePayCreds: '',
        getTorquePayCredsError: '',

        isLoading: false,
        addTorquePayCredsSuccess: '',
        addTorquePayCredsError: '',

        deleteTorquePayCredsLoading: false,
        deleteTorquePayCredsSuccess: '',
        deleteTorquePayCredsError: '',

        makeTorquePayLoading: false,
        makeTorquePaySuccess: '',
        makeTorquePayError: '',
      };
    default:
      return state;
  }
};
